<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title"><b>Contents</b><span epub:type="pagebreak" id="pagevii"></span></p>
<table style="width:100%;border-spacing:0;border-collapse:collapse;">
<colgroup>
<col style="width:40%"/>
<col style="width:60%"/>
</colgroup>
<tbody>
<tr>
<td class="td" colspan="2"><p class="toc1"><a href="#/xhtml/04_Dedication">Dedication</a></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><a href="#/xhtml/06_Acknowledgements">Acknowledgements</a></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><a href="#/xhtml/07_Glossary">Glossary</a></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><a href="#/xhtml/08_Preface">Preface</a></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><a href="#/xhtml/09_Introduction">Introduction</a></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><a href="#/xhtml/10_Chapter01">Chapter 1:</a></p></td>
<td class="td"><p class="toc1"><a href="#/xhtml/10_Chapter01"><b>The Early Camps, 1939-1940:</b></a> <a href="#/xhtml/10_Chapter01#sec_1">Oflag X (Itzehoe) September-October 1939</a>; <a href="#/xhtml/10_Chapter01#sec_2">Oflag IVC (Colditz) June 1940-April 1945</a>; <a href="#/xhtml/10_Chapter01#sec_3">Oflag IXA/H (Spangenberg) October 1939-April 1942</a></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><a href="#/xhtml/11_Chapter02">Chapter 2:</a></p></td>
<td class="td"><p class="toc1"><a href="#/xhtml/11_Chapter02"><b>Dulag Luft:</b> December 1939-April 1945</a></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">Chapter 3:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample"><b>Stalag VIIIB (Lamsdorf):</b> May 1940-January 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">Chapter 4:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample"><b>Stalag Luft I (Barth):</b> June 1940-May 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">Chapter 5:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample"><b>Wehrmacht Camps, 1941:</b></span> <span href="#/xhtml/14_Chapter05#sec_4" title="Link target outside of Sample">Oflag VIIC (Laufen) July 1941-September 1941</span>; <span href="#/xhtml/14_Chapter05#sec_5" title="Link target outside of Sample">Oflag XC (Lübeck) July 1941-October 1941</span>; <span href="#/xhtml/14_Chapter05#sec_6" title="Link target outside of Sample">Oflag VIB (Warburg) October 1941-September 1942</span>; <span href="#/xhtml/14_Chapter05#sec_7" title="Link target outside of Sample">Stalag IXC (Bad Sulza) July 1941-May 1942</span>; <span href="#/xhtml/14_Chapter05#sec_8" title="Link target outside of Sample">Stalag IIIE (Kirchhain) July 1941-May 1942</span>; <span href="#/xhtml/14_Chapter05#sec_9" title="Link target outside of Sample">Stalag VIIA (Moosburg) December 1941-September 1942</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">Chapter 6:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample"><b>Stalag Luft III (Sagan):</b> March 1942-January 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">Chapter 7:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample"><b>Wehrmacht Camps, 1942-1943:</b></span> <span href="#/xhtml/16_Chapter07#sec_10" title="Link target outside of Sample">Stalag 383 (Hohenfels) September 1942-April 1945</span>; <span href="#/xhtml/16_Chapter07#sec_11" title="Link target outside of Sample">Oflag XXIB (Schubin) October 1942-May 1943</span>; <span href="#/xhtml/16_Chapter07#sec_12" title="Link target outside of Sample">Stalag IVB (Mühlberg) June 1943-May 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">Chapter 8:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample"><b>Stalag Luft VI (Heydekrug):</b> June 1943-July 1944</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/18_Chapter09" title="Link target outside of Sample">Chapter 9:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/18_Chapter09" title="Link target outside of Sample"><b>Stalag Luft IV (Gross Tychow):</b> July 1944-February 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/19_Chapter10" title="Link target outside of Sample">Chapter 10:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/19_Chapter10" title="Link target outside of Sample"><b>Stalag 357 (Thorn and Oerbke); Stalag XIB (Fallingbostel):</b> July 1944-April 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/20_Chapter11" title="Link target outside of Sample">Chapter 11:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/20_Chapter11" title="Link target outside of Sample"><b>Stalag Luft VII (Bankau):</b> June 1944-January 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/21_Chapter12" title="Link target outside of Sample">Chapter 12:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/21_Chapter12" title="Link target outside of Sample"><b>The Last Camps:</b> Marlag und Milag Nord February 1945-April 1945</span>; <span href="#/xhtml/21_Chapter12#sec_13" title="Link target outside of Sample">Stalag IIIA (Luckenwalde) January-May 1945</span>; <span href="#/xhtml/21_Chapter12#sec_14" title="Link target outside of Sample">Stalag XIIID (Langwasser-Nürnberg) January-April 1945</span>; <span href="#/xhtml/21_Chapter12#sec_15" title="Link target outside of Sample">Stalag VIIA (Moosburg) January-April 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/22_Chapter13" title="Link target outside of Sample">Chapter 13</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/22_Chapter13" title="Link target outside of Sample"><b>Operation Exodus:</b> 1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/23_Chapter14" title="Link target outside of Sample">Chapter 14:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/23_Chapter14" title="Link target outside of Sample"><b>Wounded:</b> 1939-1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/24_Chapter15" title="Link target outside of Sample">Chapter 15:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/24_Chapter15" title="Link target outside of Sample"><b>Repatriations:</b> 1943-1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/25_Chapter16" title="Link target outside of Sample">Chapter 16:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/25_Chapter16" title="Link target outside of Sample"><b>Traitors and Collaborators:</b> 1940-1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/26_Chapter17" title="Link target outside of Sample">Chapter 17:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/26_Chapter17" title="Link target outside of Sample"><b>War Crimes, 1939-1944</b></span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/27_Chapter18" title="Link target outside of Sample">Chapter 18:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/27_Chapter18" title="Link target outside of Sample"><b>War Crimes, 1945</b></span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/28_Chapter19" title="Link target outside of Sample">Chapter 19:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/28_Chapter19" title="Link target outside of Sample"><b>Introduction to the List of RAF Bomber Command Prisoners-of-War</b></span></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><span href="#/xhtml/29_Plates" title="Link target outside of Sample">Photo Gallery</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/30_Appendix_I" title="Link target outside of Sample">Appendix I:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/30_Appendix_I" title="Link target outside of Sample">The List of RAF Bomber Command PoWs</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/31_Appendix_II" title="Link target outside of Sample">Appendix II:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/31_Appendix_II" title="Link target outside of Sample">Numbering System and Location of German PoW Camps</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/32_Appendix_III" title="Link target outside of Sample">Appendix III:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/32_Appendix_III" title="Link target outside of Sample">Periods of occupation of German PoW camps by RAF PoWs, 1939-1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/33_Appendix_IV" title="Link target outside of Sample">Appendix IV:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/33_Appendix_IV" title="Link target outside of Sample">RAF Bomber Command PoW losses, 1939-1945: by month</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/34_Appendix_V" title="Link target outside of Sample">Appendix V:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/34_Appendix_V" title="Link target outside of Sample">RAF Bomber Command PoW losses, 1939-1945: by aircraft type</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/35_Appendix_VI" title="Link target outside of Sample">Appendix VI:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/35_Appendix_VI" title="Link target outside of Sample">RAF Bomber Command PoW losses, 1939-1945: by squadron</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/36_Appendix_VII" title="Link target outside of Sample">Appendix VII:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/36_Appendix_VII" title="Link target outside of Sample">RAF Bomber Command PoW losses, 1939-1945: by rank</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/37_Appendix_VIII" title="Link target outside of Sample">Appendix VIII:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/37_Appendix_VIII" title="Link target outside of Sample">RAF Bomber Command PoW losses, 1939-1945: by nationality</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/38_Appendix_IX" title="Link target outside of Sample">Appendix IX:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/38_Appendix_IX" title="Link target outside of Sample">RAF Bomber Command PoW losses, 1939-1945: by target</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/39_Appendix_X" title="Link target outside of Sample">Appendix X:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/39_Appendix_X" title="Link target outside of Sample">RAF escapers, 1941-1945</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/40_Appendix_XI" title="Link target outside of Sample">Appendix XI:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/40_Appendix_XI" title="Link target outside of Sample">Comparative British and German Ranks</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/41_Appendix_XII" title="Link target outside of Sample">Appendix XII:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/41_Appendix_XII" title="Link target outside of Sample">The Nazi Propaganda Campaign against Airmen</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/42_Appendix_XIII" title="Link target outside of Sample">Appendix XIII:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/42_Appendix_XIII" title="Link target outside of Sample">The Nazi Party Security Forces</span></p></td>
</tr>
<tr>
<td class="td"><p class="toc1"><span href="#/xhtml/43_Appendix_XIV" title="Link target outside of Sample">Appendix XIV:</span></p></td>
<td class="td"><p class="toc1"><span href="#/xhtml/43_Appendix_XIV" title="Link target outside of Sample">Red Cross Parcels</span></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><span href="#/xhtml/43_Plans_PoW" title="Link target outside of Sample">Plans of some PoW camps used by RAF</span></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><span href="#/xhtml/44_Notes_to_Chapters" title="Link target outside of Sample">Notes to Chapters</span></p></td>
</tr>
<tr>
<td class="td" colspan="2"><p class="toc1"><span href="#/xhtml/45_Bibliography" title="Link target outside of Sample">Bibliography</span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?486b2628